import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Alert from "../assets/icons/alert.svg";

import Styles from "bundle-text:../styles/_serverConfigurationModal.scss";

interface ServerConfigurationModalProps {
  show: boolean;
  onClose: () => void;
  onBack?: () => void;
  onVerify?: () => void;
}

const ServerConfigurationModal: Component<ServerConfigurationModalProps> = (
  props
) => {
  const [ns1, setNs1] = createSignal("ns1.example.com");
  const [ns2, setNs2] = createSignal("ns2.example.com");
  const [ip1, setIp1] = createSignal("1.1.1.1");
  const [ip2, setIp2] = createSignal("2.2.2.2");

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        console.log("Copied to clipboard:", text);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };
  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={60}>
        <HeaderModal
          title="Nameservers Configuration"
          onClose={props.onClose}
        />
        <section class="server-configuration-modal-content">
          <p>
            There are two name servers, NS1 and NS2, that you must copy and
            paste into the registrar where you purchased your domain.
          </p>

          <div className="alert">
            <img src={Alert} alt="Alert" />
            <span>
              Changing the nameservers of a domain acquired externally may
              result in losing connections on the external platform.
            </span>
          </div>

          <div className="flex">
            <div className="group">
              <label htmlFor="ns1">NS1:</label>
              <div className="inline">
                <input type="text" id="ns1" value="Enter NS1" readonly />
                <button onClick={() => copyToClipboard(ns1())}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>

            <div className="group">
              <label htmlFor="ip1">IP1:</label>
              <div className="inline">
                <input type="text" id="ip1" value="Enter IP1" readonly />
                <button onClick={() => copyToClipboard(ip1())}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>
          </div>

          <div className="flex">
            <div className="group">
              <label htmlFor="ns2">NS2:</label>
              <div className="inline">
                <input type="text" id="ns2" value="Enter NS2" readonly />
                <button onClick={() => copyToClipboard(ns2())}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>

            <div className="group">
              <label htmlFor="ip2">IP2:</label>
              <div className="inline">
                <input type="text" id="ip2" value="Enter IP2" readonly />
                <button onClick={() => copyToClipboard(ip2())}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>
          </div>

          <button onClick={() => props.onVerify()}>Verify</button>
        </section>
      </DefaultModal>
    </>
  );
};

export default ServerConfigurationModal;
